import { render, staticRenderFns } from "./AccountOff.vue?vue&type=template&id=6e2da4db"
import script from "./AccountOff.vue?vue&type=script&lang=js"
export * from "./AccountOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports